/**
 * Focus next input element in Jr. Edit Mode
 * @param {*} Dyn
 * @param {*} activeEle
 */
export const focusNextInputElementInJrEditMode = function (Dyn, activeEle) {
    // TODO: Remove the jQuery reference Dyn.elemPlayContainer.plotObj
    const focusableElements = Array.from(
        Dyn.elemPlayContainer.plotObj.get(0)?.querySelectorAll("input")
    );
    if (focusableElements) {
        const currentIndex = focusableElements.indexOf(activeEle);
        const nextElement = focusableElements[currentIndex + 1];

        if (nextElement) {
            nextElement.focus();
        }
    }
};

/**
 * Check is empty
 * @param {string} value
 * @returns
 */
export const isEmptyString = function(value) {
    return value === undefined || value === null || value === "";
}
